import Treeselect from './components/Treeselect.vue'

export default Treeselect
